up.script = (function () {
    const u = up.util;
    const e = up.element;
    const config = new up.Config(() => ({
        cspNonce() { return e.metaContent('csp-nonce'); },
        cspWarnings: true,
        scriptElementPolicy: 'auto',
        evalCallbackPolicy: 'auto',
        assetSelectors: [
            'link[rel=stylesheet]',
            'script[src]',
            '[up-asset]'
        ],
        noAssetSelectors: [
            '[up-asset=false]',
        ],
        nonceableAttributes: [
            'up-watch',
            'up-on-keep',
            'up-on-hungry',
            'up-on-opened',
            'up-on-accepted',
            'up-on-dismissed',
            'up-on-loaded',
            'up-on-rendered',
            'up-on-finished',
            'up-on-error',
            'up-on-offline',
        ],
        scriptSelectors: [
            'script:not([type])',
            'script[type="text/javascript"]',
            'script[type="module"]',
            'script[type="importmap"]',
        ],
        noScriptSelectors: [
            'script[type="application/ld+json"]'
        ]
    }));
    const SYSTEM_MACRO_PRIORITIES = {
        '[up-back]': -100,
        '[up-clickable]': -200,
        '[up-drawer]': -200,
        '[up-modal]': -200,
        '[up-cover]': -200,
        '[up-popup]': -200,
        '[up-tooltip]': -200,
        '[up-dash]': -200,
        '[up-flashes]': -200,
        '[up-expand]': -300,
        '[data-method]': -400,
        '[data-confirm]': -400,
        '[up-keep]': 9999999999,
    };
    let registeredCompilers = [];
    let registeredMacros = [];
    function registerCompiler(...args) {
        registerProcessor(args);
    }
    function registerMacro(...args) {
        registerProcessor(args, { macro: true });
    }
    function registerAttrCompiler(...args) {
        let [attr, options, valueCallback] = parseProcessorArgs(args);
        let selector = `[${attr}]`;
        let { defaultValue } = options;
        let callback = (element) => {
            let value = e.booleanOrStringAttr(element, attr);
            if (value === false)
                return;
            if (u.isDefined(defaultValue) && value === true)
                value = defaultValue;
            return valueCallback(element, value);
        };
        registerProcessor([selector, options, callback]);
    }
    function detectSystemMacroPriority(macroSelector) {
        macroSelector = u.evalOption(macroSelector);
        for (let substr in SYSTEM_MACRO_PRIORITIES) {
            if (macroSelector.indexOf(substr) >= 0) {
                return SYSTEM_MACRO_PRIORITIES[substr];
            }
        }
        up.fail('Unregistered priority for system macro %o', macroSelector);
    }
    function registerProcessor(args, overrides = {}) {
        let processor = buildProcessor(args, overrides);
        if (processor.macro) {
            if (up.framework.evaling) {
                processor.priority || (processor.priority = detectSystemMacroPriority(processor.selector));
            }
            insertProcessor(registeredMacros, processor);
        }
        else {
            insertProcessor(registeredCompilers, processor);
        }
    }
    const parseProcessorArgs = function (args) {
        return u.args(args, 'val', 'options', 'callback');
    };
    function buildProcessor(args, overrides) {
        let [selector, options, callback] = parseProcessorArgs(args);
        options = u.options(options, {
            selector,
            isDefault: up.framework.evaling,
            priority: 0,
            batch: false,
            rerun: false,
        });
        return Object.assign(callback, options, overrides);
    }
    function insertProcessor(queue, newCompiler) {
        let existingCompiler;
        let index = 0;
        while ((existingCompiler = queue[index]) && (existingCompiler.priority >= newCompiler.priority)) {
            index += 1;
        }
        queue.splice(index, 0, newCompiler);
        if (up.framework.booted) {
            if (newCompiler.priority === 0) {
                for (let layer of up.layer.stack) {
                    hello(layer.element, { layer, compilers: [newCompiler], macros: [], insertedEvent: false });
                }
            }
            else {
                up.puts('up.compiler()', 'Compiler with priority (%s) was registered after booting Unpoly. Compiler will run for future fragments only.', newCompiler.selector);
            }
        }
        return newCompiler;
    }
    function registerDestructor(element, value) {
        let fns = u.scanFunctions(value);
        if (!fns.length)
            return;
        if (element.isConnected) {
            let registry = (element.upDestructors || (element.upDestructors = buildDestructorRegistry(element)));
            registry.guard(fns);
        }
        else {
            up.puts('up.destructor()', 'Immediately calling destructor for detached element (%o)', element);
            for (let fn of fns)
                up.error.guard(fn, element);
        }
    }
    function buildDestructorRegistry(element) {
        let registry = u.cleaner();
        registry(e.addClassTemp(element, 'up-can-clean'));
        return registry;
    }
    function hello(element, options = {}) {
        var _a, _b;
        element = up.fragment.get(element, options);
        let macros = (_a = options.macros) !== null && _a !== void 0 ? _a : registeredMacros;
        let compilers = (_b = options.compilers) !== null && _b !== void 0 ? _b : registeredCompilers;
        const pass = new up.HelloFragment(element, macros, compilers, options);
        return pass.run();
    }
    function clean(fragment, options = {}) {
        new up.DestructorPass(fragment, options).run();
    }
    function readData(element) {
        element = up.fragment.get(element);
        return element.upData || (element.upData = buildData(element));
    }
    function buildData(element) {
        var _a;
        let parsedJSON = (_a = e.jsonAttr(element, 'up-data')) !== null && _a !== void 0 ? _a : {};
        if (!u.isOptions(parsedJSON)) {
            return parsedJSON;
        }
        return Object.assign(Object.assign(Object.assign(Object.assign({}, element.upTemplateData), element.dataset), parsedJSON), element.upCompileData);
    }
    function findAssets(head = document.head) {
        return head.querySelectorAll(config.selector('assetSelectors'));
    }
    function assertAssetsOK(newAssets, renderOptions) {
        let { response } = renderOptions;
        let oldAssets = findAssets();
        if (assetsIdentity(oldAssets) !== assetsIdentity(newAssets)) {
            up.event.assertEmitted('up:assets:changed', { oldAssets, newAssets, renderOptions, response });
        }
    }
    function assetsIdentity(assets) {
        return u.map(assets, assetIdentity).join();
    }
    function assetIdentity(assetElement) {
        return e.removeAttrsFromHTML(assetElement.outerHTML, ['nonce']);
    }
    function block(root) {
        for (let script of findScripts(root)) {
            script.type = 'up-blocked-script';
        }
    }
    function findScripts(root, condition = '') {
        let selector = config.selector('scriptSelectors', condition);
        return e.subtree(root, selector);
    }
    function isScript(value) {
        return config.matches(value, 'scriptSelectors');
    }
    function adoptNewFragment(fragment, cspInfo) {
        new up.ScriptGate(cspInfo).adoptNewFragment(fragment);
    }
    function adoptDetachedHeadAsset(script, cspInfo) {
        new up.ScriptGate(cspInfo).adoptDetachedHeadAsset(script);
    }
    function adoptRenderOptionsFromHeader(renderOptions, cspInfo) {
        new up.ScriptGate(cspInfo).adoptRenderOptionsFromHeader(renderOptions);
    }
    function callbackAttr(element, attrName, parseOpts) {
        return e.parseAttr(element, attrName, (code) => {
            let fn = parseCallback(code, parseOpts);
            return fn.bind(element);
        });
    }
    function parseCallback(code, { argNames = ['event'], expandObject = false } = {}) {
        return function (...argValues) {
            if (expandObject) {
                let object = argValues[0];
                argNames = [...argNames, ...expandObject];
                argValues = [object, ...Object.values(u.pick(object, expandObject))];
            }
            const nonceableCallback = up.NonceableCallback.fromString(code);
            const evalEnv = { thisContext: this, argNames, argValues };
            return new up.ScriptGate().evalCallback(nonceableCallback, evalEnv);
        };
    }
    function cspNonce() {
        return u.evalOption(config.cspNonce);
    }
    function warnOfUnsafeCSP(cspInfo) {
        new up.ScriptGate(cspInfo).warnOfUnsafeCSP();
    }
    function reset() {
        registeredCompilers = u.filter(registeredCompilers, 'isDefault');
        registeredMacros = u.filter(registeredMacros, 'isDefault');
    }
    up.on('up:framework:reset', reset);
    return {
        config,
        compiler: registerCompiler,
        macro: registerMacro,
        attrCompiler: registerAttrCompiler,
        destructor: registerDestructor,
        hello,
        clean,
        data: readData,
        findAssets,
        assertAssetsOK,
        block,
        adoptNewFragment,
        adoptRenderOptionsFromHeader,
        adoptDetachedHeadAsset,
        parseCallback,
        cspNonce,
        warnOfUnsafeCSP,
        callbackAttr,
        isScript,
        findScripts,
    };
})();
up.compiler = up.script.compiler;
up.destructor = up.script.destructor;
up.macro = up.script.macro;
up.data = up.script.data;
up.hello = up.script.hello;
up.attribute = up.script.attrCompiler;
